<script lang="ts">
    import { DRAWER_POSITION } from "@/constants/drawer";
    import WishlistTheme from "@apps/wishlist/components/WishlistTheme/WishlistTheme.svelte";
    import WishlistsStorefrontValuesService from "@apps/wishlist/services/WishlistsStorefrontValuesService";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { container } from "tsyringe";

    import DrawerButton from "@components/Drawer/DrawerButton.svelte";
    import WishlistIcon from "@components/WishlistIcon/WishlistIcon.svelte";

    export let direction: DRAWER_POSITION;
    export let wishlistsStorefrontValuesService: WishlistsStorefrontValuesService;

    const wishlistBranding$ =
        wishlistsStorefrontValuesService.selectWishlistsBranding();

    const i18nModule = container.resolve(I18nModule);

    const drawer_button_label$ = i18nModule.exports.i18n.selectT(
        "wishlist.critical.WishlistDrawerWidget",
        "drawer_button_label"
    );
</script>

{#if $wishlistBranding$}
    <WishlistTheme branding={$wishlistBranding$}>
        <div class="gw-wl-drawer-button-wrapper">
            <DrawerButton
                elementName="WISHLIST_DRAWER_BUTTON"
                title={$drawer_button_label$}
                ariaLabel={"Open Wishlist sidebar"}
                {direction}
                on:click
                on:mouseenter
            >
                <WishlistIcon
                    slot="icon"
                    width={16}
                    height={16}
                    isFilled={true}
                    iconSettings={$wishlistBranding$.wishlistIconSettings}
                />
            </DrawerButton>
        </div>
    </WishlistTheme>
{/if}

<style>
    .gw-wl-drawer-button-wrapper {
        --gw-drawer-btn-bg-color: var(
            --gw-wl-wishlistDrawerAndPageSettings-launcherBackgroundColor
        );
        --gw-drawer-btn-text-color: var(
            --gw-wl-wishlistDrawerAndPageSettings-launcherFontColor
        );
        --gw-theme__main-color: var(
            --gw-wl-wishlistDrawerAndPageSettings-launcherIconBackgroundColor
        );
        --gw-drawer-btn-icon-bg-color: var(
            --gw-wl-wishlistDrawerAndPageSettings-launcherIconBackgroundColor
        );
    }
</style>
